import { render, staticRenderFns } from "./listEdit.vue?vue&type=template&id=96585600&"
import script from "./listEdit.vue?vue&type=script&lang=js&"
export * from "./listEdit.vue?vue&type=script&lang=js&"
import style0 from "./listEdit.vue?vue&type=style&index=0&id=96585600&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports